import { useEffect } from "react";
import styles from "./ConnectModal.module.css";

const ApiErrorToast = ({ error, onClose }) => {
  useEffect(() => {
    if (!error) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, 5000);

    return () => clearTimeout(timer);
  }, [error, onClose]);

  useEffect(() => {
    if (!error) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [error, onClose]);

  if (!error) return null;

  const errorMessage =
    error.error?.message || error.message || "An error occurred";
  const errorCode = error.error?.code || "ERROR";

  return (
    <div className={styles.errorToast} onClick={onClose} role="presentation">
      <div className={styles.errorContent}>
        <div className={styles.errorIcon}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#ef4444" opacity="0.15" />
            <path
              d="M12 8v4M12 16h.01"
              stroke="#ef4444"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className={styles.errorTextContainer}>
          <div className={styles.errorTitle}>{errorCode}</div>
          <div className={styles.errorMessage}>{errorMessage}</div>
        </div>
        <button
          type="button"
          className={styles.errorCloseButton}
          onClick={onClose}
          aria-label="Close error"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ApiErrorToast;
